import { render, staticRenderFns } from "./SheetGroup.vue?vue&type=template&id=996c4d56"
import script from "./SheetGroup.vue?vue&type=script&lang=js"
export * from "./SheetGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports